import React from 'react'
import Head from 'next/head'
import BiTube from '@src/routes/Configurators/products/BiTube'
import messages from '@src/routes/Configurators/messages'
import { useIntl } from 'react-intl'
import { useRouter } from '@src/routes'
import ConfiguratorPageError from '@src/routes/Configurators/utils/ConfiguratorPageError'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import getConfig from 'next/config'
import TubesMTORedesign from '@src/routes/Configurators/products/TubesMTORedesign'
import { BiTubeProduct } from '@src/routes/Configurators/products/BiTube/enum'
import { checkForRedesignedBiTubeProduct } from '@src/routes/Configurators/products/TubesMTORedesign/ProductsConfiguration'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const FastDuplexOligo = () => {
  const intl = useIntl()
  const router = useRouter()
  let product = router?.query?.product ?? ''
  const countryCode = router?.query?.country ?? ''
  let invalidProduct = false
  const productTitle = () => {
    //Convert -old to _old for message file
    if (product === BiTubeProduct.LightCyclerOld) {
      product = 'lightcycle_old'
    } else if (product === BiTubeProduct.FastDuplexOld) {
      product = 'fastduplex_old'
    } else if (product === BiTubeProduct.mirnaOld) {
      product = 'mirna_old'
    }
    const productKey = 'CONF_TITLE_' + product
    let title = intl.formatMessage({
      id: 'CONF_ERROR_PAGE',
      defaultMessage: 'Error Page',
    })
    try {
      title = intl.formatMessage(messages[productKey])
    } catch (error) {
      invalidProduct = true
    }
    return title
  }

  const getTubeComponent = () => {
    if (
      featureFlags.biTubesRedesign &&
      checkForRedesignedBiTubeProduct(product)
    ) {
      return <TubesMTORedesign />
    } else {
      return <BiTube />
    }
  }

  return (
    <React.Fragment>
      <Head>
        <title>{productTitle()}</title>
      </Head>
      {invalidProduct ? (
        <DefaultLayout spacing={LayoutSpacingOptions.MD}>
          <ConfiguratorPageError productCode={2} country={countryCode} />
        </DefaultLayout>
      ) : (
        getTubeComponent()
      )}
    </React.Fragment>
  )
}

export default FastDuplexOligo
